import { newE2EPage } from '@stencil/core/testing';

describe('salla-booking-field', () => {
  it('renders', async () => {
    const page = await newE2EPage();
    await page.setContent('<salla-booking-field></salla-booking-field>');

    const element = await page.find('salla-booking-field');
    expect(element).toHaveClass('hydrated');
  });
});
